<fgb-page-header [pageTitle]="'polls.banner.text'" [backButtonLink]="'/games'" [showFooter]="false"></fgb-page-header>

<div class="polls-page">
  <div class="polls-page-header bg-black text-white d-flex align-items-center">
    <div class="container">
      <div class="d-lg-flex d-none align-items-center mb-2 cursor-pointer" [routerLink]="['/games']">
        <span class="icon material-symbols-outlined me-2">keyboard_arrow_left</span>
        <span class="font-size-14 fw-bold">{{ 'back.to.all.games' | translate }}</span>
      </div>
      <img class="mb-lg-3 mb-2" src="assets/images/games/poll-banner.jpg" />
    </div>
  </div>

  <div class="container">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <div [ngClass]="{ 'mt-lg-4': pollsQuestions.length == 0 }">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
        </fgbcl-game-polls-question-list>
      </div>
    </ng-container>

    <!-- Shimmer Effect -->
    <ng-template #shimmerEffect>
      <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
        <h6 class="card-title placeholder-glow text-center">
          <span class="question-shimmer-effect placeholder col-6"></span>
        </h6>
        <div class="answer-shimmer-effect-section">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="answer-shimmer-effect-section mt-3">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <p class="card-text placeholder-glow w-40 text-center">
            <span class="presentby-shimmer-effect placeholder col-7"></span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
